import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import {
    ServicoTabKey,
    ServicoTabKeyHistoricoAlteracao,
} from '@/features/servico/page/edit/body/useServicoTabItems';
import { ServicoEdit } from '@/features/servico/page/edit/ServicoEdit';
import { StringToIdpkSchema } from '@/std/schema';

const RouteServicoParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteServicoParams = z.infer<typeof RouteServicoParamsSchema>;

const schema = z.union([
    z.object({
        tab1: z.literal(ServicoTabKey.HistoricoAlteracoes),
        tab2: z.enum(ServicoTabKeyHistoricoAlteracao),
    }),
    z.object({
        tab1: z.literal(ServicoTabKey.Geral).default(ServicoTabKey.Geral),
    }),
]);

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/servico/$action/{-$idpk}')({
    validateSearch: schema,
    params: {
        parse: (params) => {
            const result = RouteServicoParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    component: Component,
});

function Component() {
    const params = Route.useParams();

    return <ServicoEdit {...params} />;
}
